/** Κλειδί της εξέτασης (χρονιά + είδος) — οι επαναληπτικές έχουν δικό τους PDF εκφωνήσεων. */
export function examKey(ex: { exam_year: number; exam_kind?: string | undefined }): string {
  return String(ex.exam_year) + (ex.exam_kind === 'repeat' ? 'R' : '');
}
